export * from './lib/details-card-layout.module';

export * from './lib/details-card-layout.component';
